<p-drawer [(visible)]="visible" position="right" [modal]="true" styleClass="p-drawer-md custom-drawer">
    <h3 class="mb-4 text-xl font-semibold border-b pb-2 mt-3" style="margin-top: 10px; margin-bottom: 15px;">Advanced Filters</h3>

    <div class="p-fluid space-y-8">
        <!-- Owner Assigned -->
        <div class="flex justify-center gap-4 flex-col">
            <div class="flex items-center gap-2">
                <p-checkbox inputId="ownerAssigned" [(ngModel)]="filters.owner_assigned.checked"
                    binary="true"></p-checkbox>
                <label for="ownerAssigned" class="w-32">Owner Assigned</label>
            </div>
            <p-select [options]="conditionOptions" [(ngModel)]="filters.owner_assigned.condition"
                styleClass="w-full">
            </p-select>
        </div>

        <!-- Ticket Activity -->
        <div class="flex justify-center gap-4 flex-col">
            <div class="flex items-center gap-2">
                <p-checkbox inputId="ticketActivity" [(ngModel)]="filters.ticket_activity.checked"
                    binary="true"></p-checkbox>
                <label for="ticketActivity" class="w-32">Ticket Activity</label>
            </div>
            <p-select [options]="conditionOptions" [(ngModel)]="filters.ticket_activity.condition"  styleClass="w-full">
            </p-select>
        </div>

        <!-- Attachment -->
        <div class="flex justify-center gap-4 flex-col">
            <div class="flex items-center gap-2">
                <p-checkbox inputId="attachment" [(ngModel)]="filters.attachment.checked" binary="true"></p-checkbox>
                <label for="attachment" class="w-32">Attachment</label>
            </div>
            <p-select [options]="conditionOptions" [(ngModel)]="filters.attachment.condition"
                styleClass="w-full">
            </p-select>
        </div>
    </div>

    <div class="flex justify-between mt-6 border-t pt-3">
        <button pButton label="Clear" class="p-button-secondary"
       
        (click)="clearFilters()"></button>
        <button pButton label="Apply" class="p-button-primary"
         [loading]="filterLoading"
        [disabled]="filterLoading"
        (click)="applyFilters()"></button>
    </div>
</p-drawer>